/*@flow*/
import type { Action, StateT } from './types';
import * as I from 'immutable';

type StateRecord = I.RecordOf<StateT>;
export default function reducer(s: StateRecord, action: Action): StateRecord {
  const { payload } = action;
  switch (action.type) {
    case 'SET_KEYPATH':
      s = s.setIn(payload.keyPath, payload.value);
      break;
    case 'UPDATE_KEYPATH':
      s = s.updateIn(payload.keyPath, payload.value);
      break;
    case 'REMOVE_KEYPATH':
      s = (s: any).deleteIn(payload.keyPath);
      break;
    default:
      break;
  }
  return s;
}
